import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { IntervalService } from '../services/interval.service';
import { DupsCheck, GapsCheck, IntervalRelatedCheck, OverlapCheck, StartAtZeroCheck } from './handlers';
import { CrossTableParams } from './models/cross-table-params-type';
import { ErrorCodes, FormActionTypeEnum } from '@shared';
import { LoggingService } from '@shared/logging';
import { QueryParamsProvider } from '@domain/routing';
import { DataRepository, WorkspaceDatabaseKeys } from '@database/workspace';
@Injectable()
export class AsyncValidatorsOrchestratorService {
	public constructor(
		private dataService: IntervalService,
		private loggerService: LoggingService,
		private queryParamsProvider: QueryParamsProvider,
		private dataRepository: DataRepository,
	) {}

	public async startProcess(crossTableParams: CrossTableParams): Promise<ValidationErrors | null> {
		const intervalRelatedHandler = new IntervalRelatedCheck(this.dataService);
		const overlapsHandler = new OverlapCheck(this.dataService);
		const duplicateHandler = new DupsCheck(this.dataService, this.dataRepository, this.queryParamsProvider);
		const gapsHandler = new GapsCheck(
			this.dataService,
			this.queryParamsProvider.formActionType() === FormActionTypeEnum.edit
		);
		const startAtZeroHandler = new StartAtZeroCheck(this.dataService);

		try {
			if (crossTableParams.crossControlKey == WorkspaceDatabaseKeys.columns.depth) {
				return await intervalRelatedHandler.handle(crossTableParams);
			} else {
				intervalRelatedHandler.setNext(overlapsHandler);
				overlapsHandler.setNext(duplicateHandler);
				duplicateHandler.setNext(gapsHandler);
				gapsHandler.setNext(startAtZeroHandler);
				return await intervalRelatedHandler.handle(crossTableParams);
			}
		} catch (error) {
			this.loggerService.error(ErrorCodes.AsyncValidationOrchestrator, error);
			throw error;
		}
	}
}
